import React, { createContext, useContext } from "react";

interface StaticGroupWizardCtx {
  groupId?: string;
}

const StaticGroupWizardContext = createContext<StaticGroupWizardCtx>({});

export const StaticGroupWizardProvider: React.FC<{
  groupId?: string;
  children: React.ReactNode;
}> = ({ groupId, children }) => (
  <StaticGroupWizardContext.Provider value={{ groupId }}>
    {children}
  </StaticGroupWizardContext.Provider>
);

export const useStaticGroupWizardContext = (): StaticGroupWizardCtx =>
  useContext(StaticGroupWizardContext);
